<template>
  <div class="card">
    <div
      class="card-header px-2 py-1"
      :class="elementHeaderClass"
    >
      <div class="w-100 text-center text-white text-xl">
        <img
          v-if="elementFlag != ''"
          :src="elementFlag"
          width="35"
          class="border-white rounded-sm position-absolute left-2"
        >

        {{ elementName }}
      </div>
      <div class="w-100 text-center text-white text-md">
        {{ elementReadableSlug }}
      </div>
    </div>
    <div
      v-if="elementSlug == 'lotto_thai'"
      class="card-body px-1 py-1"
    >
      <div class="d-flex">
        <div class="flex-width text-center">
          <small class="text-md">รางวัลที่ 1</small>
        </div>
      </div>
      <div class="d-flex border-bottom mb-3 pb-3">
        <div
          v-if="elementStatus == 1"
          class="flex-width text-center"
          :class="elementBodyClass"
        >
          {{ results[0].result_value }}
        </div>
        <div
          v-else
          class="flex-width text-center"
          :class="elementBodyClass"
        >
          รอผล
        </div>
      </div>
      <div class="d-flex">
        <div class="flex-width text-center">
          <small class="text-md">สามตัวหน้า</small>
        </div>
        <div class="flex-width text-center border-left border-right">
          <small class="text-md">สามตัวหลัง</small>
        </div>
        <div class="flex-width text-center">
          <small class="text-md">2ตัวล่าง</small>
        </div>
      </div>
      <div class="d-flex">
        <div
          v-if="elementStatus == 1"
          class="flex-width text-center"
          :class="elementBodyClass"
        >
          {{ results[3].result_value }} , {{ results[2].result_value }}
        </div>

        <div
          v-else
          class="flex-width text-center"
          :class="elementBodyClass"
        >
          รอผล
        </div>

        <div
          v-if="elementStatus == 1"
          class="flex-width text-center border-left border-right"
          :class="elementBodyClass"
        >
          {{ results[5].result_value }} , {{ results[4].result_value }}
        </div>

        <div
          v-else
          class="flex-width text-center"
          :class="elementBodyClass"
        >
          รอผล
        </div>

        <div
          v-if="elementStatus == 1"
          class="flex-width text-center"
          :class="elementBodyClass"
        >
          {{ results[1].result_value }}
        </div>
        <div
          v-else
          class="flex-width text-center"
          :class="elementBodyClass"
        >
          รอผล
        </div>
      </div>
    </div>
    <div
      v-else
      class="card-body px-1 py-1"
    >
      <div class="d-flex">
        <div class="flex-width text-center">
          <small class="text-md">สามตัวบน</small>
        </div>
        <div class="flex-width text-center border-left">
          <small class="text-md">สองตัวล่าง</small>
        </div>
      </div>
      <div class="d-flex">
        <div
          v-if="elementStatus == 1"
          class="flex-width text-center"
          :class="elementBodyClass"
        >
          {{ results[1].result_value }}
        </div>
        <div
          v-else
          class="flex-width text-center"
          :class="elementBodyClass"
        >
          รอผล
        </div>
        <div
          v-if="elementStatus == 1"
          class="flex-width text-center border-left"
          :class="elementBodyClass"
        >
          {{ results[0].result_value }}
        </div>
        <div
          v-else
          class="flex-width text-center"
          :class="elementBodyClass"
        >
          รอผล
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Results',
  props: {
    elementName: {
      type: String,
      default: '',
    },
    elementFlag: {
      type: String,
      default: '',
    },
    elementReadableSlug: {
      type: String,
      default: '',
    },
    elementSlug: {
      type: String,
      default: '',
    },
    results: {
      type: Array,
      default: '',
    },
    elementStatus: {
      type: Number,
      default: '',
    },
    elementHeaderClass: {
      type: String,
      default: '',
    },
    elementBodyClass: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      result_title: [],
    };
  },

  mounted() {
    if (this.elementSlug == 'lotto_thai') {
      this.result_title = ['สามตัวบน', 'สองตัวล่าง'];
    } else {
      this.result_title = [
        'รางวัลที่ 1',
        'สามตัวหน้า',
        'สามตัวหลัง',
        'สองตัวล่าง',
      ];
    }
  },

  methods: {},
};
</script>
